<template>
    <div>
        <van-collapse v-model="activate">
            <div style="text-align: center">
                <div v-for="(item,index) in images">
                    <van-collapse-item v-if="item.picture.length > 0" :title="item.pictureTypeName" :name="index">
                        <van-row>
                            <van-col span="8" v-for="(file,index) in item.picture">
                                <img v-if="file.fileType === 0" :src="file.thumbUrl" width="100" height="100" style="margin-left: 5px;" @click="showImage(item.picture,index)"/>
                                <img v-if="file.fileType === 1" :src="file.thumbUrl" width="100" height="100" style="margin-left: 5px;" @click="showPdf(file)"/>
                                <img v-if="file.fileType === 2" :src="file.thumbUrl" width="100" height="100" style="margin-left: 5px;" @click="downFile(file)"/>
                                <img v-if="file.fileType === 3" :src="file.thumbUrl" width="100" height="100" style="margin-left: 5px;" @click="downFile(file)"/>
                                <img v-if="file.fileType === 4" :src="file.thumbUrl" width="100" height="100" style="margin-left: 5px;" @click="showVideo(file)"/>
                                <img v-if="file.fileType === 5" :src="file.thumbUrl" width="100" height="100" style="margin-left: 5px;" @click="downFile(file)"/>
                            </van-col>
                        </van-row>
                    </van-collapse-item>
                </div>
            </div>
        </van-collapse>
        <van-popup
                position="top"
                v-model="previewPdf"
                :overlay="true" :style="{ height: '100%' }"
                closeable
                close-icon="close">
            <iframe style="width: 100%; height:100%" :src="pdfSrc"></iframe>
        </van-popup>

        <van-popup
                position="top"
                v-model="previewVideo"
                :overlay="true" :style="{ height: '100%' }"
                closeable
                close-icon="close">
            <div style="display: flex;justify-content: center;height: 100%;align-items: center">
                <video :src="videoSrc" controls="controls">
                    您的浏览器不支持视频预览，请使用Chrome内核的浏览器，谢谢！
                </video>
            </div>
        </van-popup>
    </div>

</template>

<script>
    import {ImagePreview} from 'vant'
    import {getApplyData} from '@/api/loanInfo'
    import icFile from '@/assets/home/ic_file.png'
    import { word, excel, ppt, pdf, mp4 } from '@/utils/iconBase64'
    const imageReg = /\.(jpg|JPG|jpeg|JPEG|png|PNG|)$/;
    const docReg = /\.(doc|DOC|docx|DOCX|)$/;
    const xlsReg = /\.(xls|XLS|xlsx|XLSX|)$/;
    const pptReg = /\.(ppt|PPT|pptx|PPTX|)$/;
    const videoReg = /\.(mp4|MP4|m4v|M4V|)$/;
    const pdfReg = /\.(pdf|PDF|)$/;
    export default {
        name: 'oss-foreclosure-apply-data',
        props: {
            applyId: {
                type: String,
                default: ''
            }
        },
        components: {
        },
        data() {
            return {
                activate: [],
                images: [],
                previewPdf: false,
                previewVideo: false,
                pdfSrc: '',
                videoSrc: '',
            }
        },
        mounted() {
            this.initData()
        },
        methods: {
            handleFileType(item) {
                // jpg、jpeg、png、xls、xlsx、doc、docx、ppt、pptx、pdf、m4v、mp4
                if (this.imageRegExp.test(item.fileSuffix)) {

                }
            },
            initData() {
                this.images = []
                this.getFileList()
            },
            getFileList() {
                const self = this
                let params = {
                    applyId: this.applyId
                }
                getApplyData(params).then(res => {
                    if (res.success) {
                        res.data.forEach(item => {
                            // 处理文件格式 0 图片, 1 pdf, 2 doc, 3 xls,4 mp4 5 ppt
                            item.picture.forEach(item => {
                                if (imageReg.test(item.fileSuffix)) {
                                    item.fileType = 0
                                } else if (pdfReg.test(item.fileSuffix)) {
                                    item.fileType = 1
                                    item.thumbUrl = pdf
                                } else if (docReg.test(item.fileSuffix)) {
                                    item.fileType = 2
                                    item.thumbUrl = word
                                } else if (xlsReg.test(item.fileSuffix)) {
                                    item.fileType = 3
                                    item.thumbUrl = excel
                                } else if (videoReg.test(item.fileSuffix)) {
                                    item.fileType = 4
                                    item.thumbUrl = mp4
                                } else if (pptReg.test(item.fileSuffix)) {
                                    item.fileType = 5
                                    item.thumbUrl = ppt
                                }
                            })
                        })
                        this.images = res.data
                    }
                })
            },
            showImage(data, index) {
                let currentItem = data[index]
                let imgs = []
                data.forEach(item => {
                    if(item.fileType === 0){
                        imgs.push(item.url)
                    }
                })
                const instance = ImagePreview({
                    images: imgs,
                    lazyLoad: true,
                    startPosition: typeof index === 'number' ? index : 0
                })
            },
            showPdf(data) {
                this.pdfSrc = data.url
                this.previewPdf = true
            },
            showVideo(data) {
                this.videoSrc = data.url
                this.previewVideo = true
            },
            downFile(data) {
                window.location.href = data.url
            }
        }
    }
</script>

<style scoped>

</style>
